// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"9f8eac76","186":"2d5cb445","272":"7c76f40b","372":"28df03ee","738":"3f640e8f","841":"6064794a","851":"6cdb0b92","856":"2c9595f8"}[chunkId] + ".chunk.js";
};